import { STATUSES } from '@/constants/common/message.constants'

import { type TruckTypeImportJobExEntity } from '../../aspida/@types'

/**
 * 車両属性取込ステータス
 */
export type TruckTypeImportJobStatusType = TruckTypeImportJobExEntity['status']

export const TRUCK_TYPE_IMPORT_JOB_STATUS_TYPE = {
  /** 取込待ち */
  PENDING: 'PENDING',
  /** 取込中 */
  IMPORTING: 'IMPORTING',
  /** 完了 */
  COMPLETED: 'COMPLETED',
  /** エラー */
  ERROR: 'ERROR'
} as const satisfies Record<
  TruckTypeImportJobStatusType,
  TruckTypeImportJobStatusType
>

export const TRUCK_TYPE_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [TRUCK_TYPE_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [TRUCK_TYPE_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.PROCESSING,
  [TRUCK_TYPE_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [TRUCK_TYPE_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED
} as const satisfies Record<TruckTypeImportJobStatusType, string>
